import { render, staticRenderFns } from "./v-doc-chip.vue?vue&type=template&id=1d5a9e0a&"
import script from "./v-doc-chip.vue?vue&type=script&lang=js&"
export * from "./v-doc-chip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports